import React, { useEffect, useState } from 'react';import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit, faArrowUp, faArrowDown, faSync } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import './ContactoData.css'
import 'jspdf-autotable';
import baseURL from '../../url';
import NewContact from '../NewContact/NewContact';
import { useData } from '../../DataContext';
import { useLogo } from '../../LogoContext';
import { useTheme } from '../../ThemeContext';
export default function ContactoData() {
    const { contacto: contactoData, cargarContacto: cargarContactoCtx } = useData();
    const { logo, cargarLogo } = useLogo();
    const { color, cargarColor } = useTheme();
    const COLORES = ['#0D9488', '#2563EB', '#7C3AED', '#DB2777', '#DC2626', '#EA580C', '#CA8A04', '#16A34A', '#0F172A', '#000000'];
    const [colorSeleccionado, setColorSeleccionado] = useState(color);
    const [colorEnviando, setColorEnviando] = useState(false);
    const contactos = Array.isArray(contactoData) ? contactoData : (contactoData ? [contactoData] : []);
    const [logoFile, setLogoFile] = useState(null);
    const [logoPreview, setLogoPreview] = useState(null);
    const [logoEnviando, setLogoEnviando] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [nuevoNombre, setNuevoNombre] = useState('');
    const [nuevoTelefono, setNuevoTelefono] = useState('');
    const [nuevoInstagram, setNuevoInstagram] = useState('');
    const [nuevoEmail, setNuevoEmail] = useState('');
    const [nuevaDireccion, setNuevaDieccion] = useState('');
    const [nuevofacebook, setNuevofacebook] = useState('');
    const [contacto, setContacto] = useState({});
    const [selectedSection, setSelectedSection] = useState('texto');

    useEffect(() => {
        setColorSeleccionado(color);
    }, [color]);

    const eliminarContacto = (idContacto) => {
        // Reemplaza el window.confirm con SweetAlert2
        Swal.fire({
            title: '¿Estás seguro?',
            text: '¡No podrás revertir esto!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                fetch(`${baseURL}/contactoDelete.php?idContacto=${idContacto}`, {
                    method: 'DELETE',
                })
                    .then(response => response.json())
                    .then(data => {
                        Swal.fire(
                            '¡Eliminado!',
                            data.mensaje,
                            'success'
                        );
                        cargarContactoCtx();
                    })
                    .catch(error => {
                        console.error('Error al eliminar contacto:', error);
                        toast.error(error);
                    });
            }
        });
    };

    const abrirModal = (item) => {
        setContacto(item);
        setNuevoNombre(item.nombre);
        setNuevoTelefono(item.telefono);
        setNuevoInstagram(item.instagram);
        setNuevoEmail(item.email);
        setNuevaDieccion(item.direccion);
        setNuevofacebook(item.facebook);
        setModalVisible(true);
    };

    const cerrarModal = () => {
        setModalVisible(false);
    };



    const handleUpdateText = (idContacto) => {
        const payload = {
            nombre: nuevoNombre !== '' ? nuevoNombre : contacto.nombre,
            telefono: nuevoTelefono !== '' ? nuevoTelefono : contacto.telefono,
            instagram: nuevoInstagram !== '' ? nuevoInstagram : contacto.instagram,
            email: nuevoEmail !== '' ? nuevoEmail : contacto.email,
            direccion: nuevaDireccion !== '' ? nuevaDireccion : contacto.direccion,
            facebook: nuevofacebook !== '' ? nuevofacebook : contacto.facebook,
        };

        fetch(`${baseURL}/contactoPut.php?idContacto=${idContacto}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        })
            .then(response => response.json())
            .then(data => {
                if (data.error) {
                    Swal.fire(
                        'Error!',
                        data.error,
                        'error'
                    );
                } else {
                    Swal.fire(
                        'Editado!',
                        data.mensaje,
                        'success'
                    );
                    cargarContactoCtx();
                    cerrarModal();
                }
            })
            .catch(error => {
                console.log(error.message);
                toast.error(error.message);
            });
    };



    const handleSectionChange = (section) => {
        setSelectedSection(section);
    };

    const handleLogoChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setLogoFile(file);
            setLogoPreview(URL.createObjectURL(file));
        }
    };

    const subirLogo = async () => {
        if (!logoFile) {
            toast.error('Seleccioná una imagen para el logo');
            return;
        }
        setLogoEnviando(true);
        try {
            const formData = new FormData();
            formData.append('logo', logoFile);
            const response = await fetch(`${baseURL}/contactoLogoPost.php`, { method: 'POST', body: formData });
            const data = await response.json();
            if (data.mensaje) {
                toast.success(data.mensaje);
                setLogoFile(null);
                setLogoPreview(null);
                cargarLogo();
            } else if (data.error) {
                toast.error(data.error);
            }
        } catch (error) {
            console.error('Error al subir logo:', error);
            toast.error('Error de conexión');
        } finally {
            setLogoEnviando(false);
        }
    };

    const guardarColor = async () => {
        setColorEnviando(true);
        try {
            const response = await fetch(`${baseURL}/temaPut.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ color: colorSeleccionado.toUpperCase() }),
            });
            const data = await response.json();
            if (data.error) {
                toast.error(data.error);
            } else {
                cargarColor(data.color || colorSeleccionado.toUpperCase());
                toast.success(data.mensaje || 'Color actualizado');
            }
        } catch (error) {
            console.error('Error al actualizar color:', error);
            toast.error('Error de conexión');
        } finally {
            setColorEnviando(false);
        }
    };
    return (
        <div>

            <ToastContainer />

            {contactos.length === 0 && <NewContact />}

            <div style={{
                background: '#fff',
                border: '1px solid var(--gris2)',
                borderRadius: '12px',
                padding: '16px',
                marginBottom: '16px',
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
                flexWrap: 'wrap',
            }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }}>
                    <img
                        src={logoPreview || logo}
                        alt="Logo del sistema"
                        style={{
                            width: '64px',
                            height: '64px',
                            borderRadius: '50%',
                            objectFit: 'cover',
                            border: '2px solid var(--color1)',
                            background: 'var(--gris)',
                        }}
                    />
                    <span style={{ fontSize: '12px', color: 'var(--text-color2)' }}>Logo del sistema</span>
                </div>
                <input type="file" accept="image/*" onChange={handleLogoChange} />
                {logoEnviando ? (
                    <button className='btnLoading' disabled style={{ marginTop: 0 }}>Subiendo...</button>
                ) : (
                    <button className='btnPost' onClick={subirLogo} style={{ marginTop: 0 }}>Guardar logo</button>
                )}
            </div>

            <div style={{
                background: '#fff',
                border: '1px solid var(--gris2)',
                borderRadius: '12px',
                padding: '16px',
                marginBottom: '16px',
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
                flexWrap: 'wrap',
            }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }}>
                    <span
                        style={{
                            width: '64px',
                            height: '64px',
                            borderRadius: '50%',
                            background: colorSeleccionado,
                            border: '2px solid var(--gris2)',
                        }}
                    />
                    <span style={{ fontSize: '12px', color: 'var(--text-color2)' }}>{colorSeleccionado.toUpperCase()}</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                    {COLORES.map((c) => (
                        <button
                            key={c}
                            type='button'
                            onClick={() => setColorSeleccionado(c)}
                            aria-label={`Elegir color ${c}`}
                            style={{
                                width: '30px',
                                height: '30px',
                                borderRadius: '50%',
                                border: colorSeleccionado.toUpperCase() === c ? '2px solid var(--text-color)' : '2px solid transparent',
                                background: c,
                                cursor: 'pointer',
                            }}
                        />
                    ))}
                    <input
                        type='color'
                        value={colorSeleccionado}
                        onChange={(e) => setColorSeleccionado(e.target.value)}
                        aria-label='Color personalizado'
                        style={{ width: '42px', height: '34px', padding: '2px', cursor: 'pointer' }}
                    />
                </div>
                {colorEnviando ? (
                    <button className='btnLoading' disabled style={{ marginTop: 0 }}>Guardando...</button>
                ) : (
                    <button className='btnPost' onClick={guardarColor} style={{ marginTop: 0 }}>Guardar color</button>
                )}
            </div>




            {modalVisible && (
                <div className="modal">
                    <div className="modal-content">
                        <div className='deFlexBtnsModal'>

                            <div className='deFlexBtnsModal'>
                                <button
                                    className={selectedSection === 'texto' ? 'selected' : ''}
                                    onClick={() => handleSectionChange('texto')}
                                >
                                    Editar Texto
                                </button>

                            </div>
                            <span className="close" onClick={cerrarModal}>
                                &times;
                            </span>
                        </div>
                        <div className='sectiontext' style={{ display: selectedSection === 'texto' ? 'flex' : 'none' }}>
                            <div className='flexGrap'>
                                <fieldset>
                                    <legend>Nombre</legend>
                                    <input
                                        type="text"
                                        value={nuevoNombre}
                                        onChange={(e) => setNuevoNombre(e.target.value)}
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Telefono</legend>
                                    <input
                                        type="number"
                                        value={nuevoTelefono}
                                        onChange={(e) => setNuevoTelefono(e.target.value)}
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Instagram</legend>
                                    <input
                                        type="url"
                                        value={nuevoInstagram}
                                        onChange={(e) => setNuevoInstagram(e.target.value)}
                                    />
                                </fieldset>
                                <fieldset >
                                    <legend>email</legend>
                                    <input
                                        type="email"
                                        value={nuevoEmail}
                                        onChange={(e) => setNuevoEmail(e.target.value)}
                                    />
                                </fieldset>
                                <fieldset >
                                    <legend>Direccion</legend>
                                    <input
                                        type="text"
                                        value={nuevaDireccion}
                                        onChange={(e) => setNuevaDieccion(e.target.value)}
                                    />
                                </fieldset>
                                <fieldset >
                                    <legend>Facebook</legend>
                                    <input
                                        type="text"
                                        value={nuevofacebook}
                                        onChange={(e) => setNuevofacebook(e.target.value)}
                                    />
                                </fieldset>
                            </div>




                            <button className='btnPost' onClick={() => handleUpdateText(contacto.idContacto)} >Guardar </button>

                        </div>




                    </div>
                </div>
            )}
            <div className='table-container'>
                <table className='table'>
                    <thead>
                        <tr>
                            <th>Id Contacto</th>
                            <th>Nombre</th>
                            <th>Telefono</th>
                            <th>Instagram</th>
                            <th>Facebook</th>
                            <th>Email</th>
                            <th>Direccion</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {contactos.map(item => (
                            <tr key={item.idContacto}>
                                <td>{item.idContacto}</td>
                                <td>{item.nombre}</td>
                                <td>{item.telefono}</td>
                                <td>{item.instagram}</td>
                                <td>{item.facebook}</td>
                                <td>{item.email}</td>
                                <td>{item.direccion}</td>
                                <td>

                                    <button className='eliminar' onClick={() => eliminarContacto(item.idContacto)}>
                                        <FontAwesomeIcon icon={faTrash} />
                                    </button>
                                    <button className='editar' onClick={() => abrirModal(item)}>
                                        <FontAwesomeIcon icon={faEdit} />
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>

                </table>
            </div>
        </div>
    );
};
